module.exports = __webpack_public_path__ + "static/media/active_profile.90452955.svg";